<script>
export default {
  props: ["value", "maxPage"],
  data() {
    return {
      pageNo: this.value
    }
  },
  mounted() {
  },

  methods: {
    // ------------------------------------------------------------------------
    showPgBtn(pgNo) {
      return (1 <= pgNo && pgNo <= this.maxPage)
    },
    // ------------------------------------------------------------------------
    pageSkip(cnt) {
      this.toPage(this.pageNo + cnt);
    },
    // ------------------------------------------------------------------------
    toPage(cnt) {
      let i = Math.max(1, Math.min(cnt, this.maxPage));
      if (this.pageNo !== i) {
        this.pageNo = i;
        this.$emit('input', this.pageNo)
      }
    },
    // ------------------------------------------------------------------------
  },
};
</script>

<template >
  <div class="pagination">
    <ul unselectable="on">
      <div class="mx-3 float-left" v-if="showPgBtn(pageNo - 1)" @click="pageSkip(-1)"><a rel="nofollow">&lsaquo; Previous</a></div>
      <div class="mx-3 float-left disabled" v-else>&lsaquo; Previous</div>
      <li title="First" class="pagination-item" v-show="showPgBtn(pageNo - 4)" @click="toPage(1)"><a rel="nofollow">1</a></li>
      <li title="Previous" class="pagination-item" v-show="showPgBtn(pageNo - 5)" @click="pageSkip(-7)"><a rel="nofollow">&#183;&#183;&#183;</a></li>
      <li class="pagination-item" v-show="showPgBtn(pageNo - 3)" @click="pageSkip(-3)"><a rel="nofollow">{{ pageNo - 3 }}</a></li>
      <li class="pagination-item" v-show="showPgBtn(pageNo - 2)" @click="pageSkip(-2)"><a rel="nofollow">{{ pageNo - 2 }}</a></li>
      <li class="pagination-item" v-show="showPgBtn(pageNo - 1)" @click="pageSkip(-1)"><a rel="nofollow">{{ pageNo - 1 }}</a></li>
      <li class="pagination-item selected" v-show="showPgBtn(pageNo) && maxPage > 1"><a rel="nofollow">{{ pageNo }}</a></li>
      <li class="pagination-item" v-show="showPgBtn(pageNo + 1)" @click="pageSkip(1)"><a rel="nofollow">{{ pageNo + 1 }}</a></li>
      <li class="pagination-item" v-show="showPgBtn(pageNo + 2)" @click="pageSkip(2)"><a rel="nofollow">{{ pageNo + 2 }}</a></li>
      <li class="pagination-item" v-show="showPgBtn(pageNo + 3)" @click="pageSkip(3)"><a rel="nofollow">{{ pageNo + 3 }}</a></li>
      <li title="Next" class="pagination-item" v-show="showPgBtn(pageNo + 5)" @click="pageSkip(7)"><a rel="nofollow">&#183;&#183;&#183;</a></li>
      <li title="Last" class="pagination-item" v-show="showPgBtn(pageNo + 4)" @click="toPage(maxPage)"><a rel="nofollow">{{ maxPage }}</a>
      </li>
      <div class="mx-3 float-right" v-if="showPgBtn(pageNo + 1)" @click="pageSkip(1)"><a rel="nofollow">Next &rsaquo;</a></div>
      <div class="mx-3 float-right disabled" v-else>Next &rsaquo;</div>
    </ul>
  </div>
</template>

<style scoped>
.pagination {
  display: block;
  text-align: center;
  margin: 0.5rem 0;
}

.disabled {
  pointer-events: none;
  cursor: default;
  opacity: 0.6;
}

.pagination ul {
  border: 1px solid #b9cebc;
  border-radius: 2px;
  padding: 0.4rem 0;
}

.pagination ul li {
  padding: 0.6rem 0.8rem;
  border: 1px solid #b9cebc;
  border-style: none solid;
}

.pagination-item {
  display: inline;
  text-align: center;
  list-style: none;
  outline: 0;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  user-select: none;
}

.pagination .selected {
  border: 1px solid #169b37;
  /* border-radius: 2px; */
}
</style>